const wordList8 = [
  // Słówka z rozdziału Obowiązki w Domu (Pflichten im Haushalt)
  { "de": "das Bett machen", "pl": "słać łóżko" },
  { "de": "einkäufe mahen", "pl": "robić zakupy" },
  { "de": "gießen", "pl": "podlewać" },
  { "de": "die Blumen gießen", "pl": "podlewać kwiaty" },
  { "de": "der Müll", "pl": "śmieci" },
  { "de": "putzen", "pl": "czyścić, sprzątać" },
  { "de": "das Bad putzen", "pl": "sprzątać łazienkę" },
  { "de": "saugen", "pl": "odkurzać" },
  { "de": "das Wohnzimmer saugen", "pl": "odkurzać w salonie" },
  { "de": "spülen", "pl": "zmywać" },
  { "de": "das Geschirr spülen", "pl": "zmywać naczynia" },
  { "de": "streiten", "pl": "spierać się" },

  // Słówka z rozdziału Pomieszczenia (Räume)
  { "de": "das Bad", "pl": "łazienka" },
  { "de": "das Kinderzimmer", "pl": "pokój dziecięcy" },
  { "de": "die Küche", "pl": "kuchnia" },
  { "de": "das Schlafzimmer", "pl": "sypialnia" },
  { "de": "die Toilette", "pl": "toaleta" },
  { "de": "das Vorzimmer", "pl": "przedpokój" },
  { "de": "das Wohnzimmer", "pl": "salon" },
  { "de": "das Zimmer", "pl": "pokój" },
  
  // Słówka z rozdziału Cechy (Eigenschaften)
  { "de": "altmodisch", "pl": "staromodny" },
  { "de": "chaotisch", "pl": "chaotyczny" },
  { "de": "dunkel", "pl": "ciemny" },
  { "de": "hässlich", "pl": "brzydki" },
  { "de": "hell", "pl": "jasny" },
  { "de": "modern", "pl": "nowoczesny" },
  { "de": "ordentlich", "pl": "uporządkowany" },
  { "de": "praktisch", "pl": "praktyczny" },
  { "de": "sauber", "pl": "czysty" },
  { "de": "schön", "pl": "piękny" },
  { "de": "schlimm", "pl": "niedobry" },
  { "de": "schrecklich", "pl": "straszny" },
  { "de": "unpraktisch", "pl": "niepraktyczny" },
  { "de": "vintage", "pl": "staroświecki, na modzie z przeszłości" },

  // Słówka z rozdziału Położenie (Die Lage)
  { "de": "auf dem Boden", "pl": "na podłodze, ziemi" },
  { "de": "die Ecke", "pl": "róg" },
  { "de": "die Mitte", "pl": "środek" },
  { "de": "links", "pl": "po lewej stronie" },
  { "de": "rechts", "pl": "po prawej stronie" },
  { "de": "oben", "pl": "na górze" },
  { "de": "unten", "pl": "na dole" },
  { "de": "überall", "pl": "wszędzie" },

  // Słówka z rozdziału Mebel i Wyposażenie (Möbel und Einrichtung)
  { "de": "das Bett", "pl": "łóżko" },
  { "de": "die Dusche", "pl": "prysznic" },
  { "de": "der Fernseher", "pl": "telewizor" },
  { "de": "die Kommode", "pl": "komoda" },
  { "de": "der Kühlschrank", "pl": "lodówka" },
  { "de": "das Regal", "pl": "regał" },
  { "de": "der Schrank", "pl": "szafa" },
  { "de": "der Schreibtisch", "pl": "biurko" },
  { "de": "das Sofa", "pl": "fotel, kanapa" },
  { "de": "die Spüle", "pl": "zlewozmywak" },
  { "de": "der Stuhl", "pl": "krzesło" },
  { "de": "die Tür", "pl": "drzwi" },

  // Słówka z rozdziału Dom i Mieszkanie (Haus und Wohnung)
  { "de": "der Altbau", "pl": "stare budownictwo, kamienica" },
  { "de": "der Bauernhof", "pl": "gospodarstwo wiejskie" },
  { "de": "das Einfamilienhaus", "pl": "dom jednorodzinny" },
  { "de": "der Garten", "pl": "ogród" },
  { "de": "das Haus", "pl": "dom" },
  { "de": "die Wohnung", "pl": "mieszkanie" },

   // Słówka z rozdziału Miejsce zamieszkania (wohnort)
  { "de": "der Ort", "pl": "miejsowość" },
  { "de": "die Altstadt", "pl": "stare miasto, starówka" },
  { "de": "das Land", "pl": "wieś" },
  { "de": "die Stadt", "pl": "Miasto" },
  { "de": "die Kleinstadt", "pl": "miasteczko" },
];

export default wordList8;